<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <v-btn 
        icon
        class="mx-1"
        :outlined="false"
        to="/">
          <v-avatar>
            <img
              alt="Avatar"
              src="@/assets/firework.png"
            >
          </v-avatar>
      </v-btn>

      <v-card-title>
        Applause
      </v-card-title>

      <v-spacer></v-spacer>

      <v-btn v-if="$route.path === '/' && user.status === 'loggedIn'"
        icon
        to="/admin">
          <v-icon>mdi-cog</v-icon>
      </v-btn>
      <v-btn v-else-if="$route.path === '/' && user.status !== 'loggedIn'"
        icon
        to="/login">
          <v-icon>mdi-login</v-icon>
      </v-btn>

    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
  import { mapState } from 'vuex'


  export default {
    name: 'App',

    components: {

    },

    computed: {
        ...mapState({ user: 'user'})
    },

    data: () => ({
      //
    }),

    created() {
    }
  }
</script>

<style>
  .clap-hand {
    position:absolute;
    rotate: 50deg;
    color: rgba(80, 80, 80, 0.5);
    left: 9px;
    top: 1px;
  }
</style>